const discoveryTutorial = {
  module: 'discovery',
  moduleName: 'Discovery',
  steps: [
    {
      target: '.md-devices-table, .devices-table, .md-page table',
      position: 'top',
      title: 'Device List',
      description: 'All discovered devices on your network with type, manufacturer, and status.',
    },
    {
      target: '.page-header-actions .btn-primary',
      position: 'bottom',
      title: 'Network Scan',
      description: 'Run a new scan to discover recently added devices.',
    },
  ],
};

export default discoveryTutorial;
